import classNames from "classnames";
import React, { FunctionComponent, memo } from "react";
import { LoadingIconProps } from "react-select/src/components/indicators";

import { marginClass } from "../../../../../Style";
import { Loader } from "./Loader";

export const LoadingIndicator: FunctionComponent<LoadingIconProps<any>> = memo(() => {
  const classes = classNames(marginClass([false, "sm", false, false]));
  return <Loader className={classes} size="xs" />;
});
